import axios from "../service/axios";
import { toast } from "react-toastify";

export const getWarehouseLayout = async (layoutId) => {
    try {
      const { data:{data : warehouseLayout} } = await axios.get(`warehouse-layout/${layoutId}`);
      return warehouseLayout;
    } catch (error) {
      toast.error('Error while fetching warehouse layout');
      console.log("error", error);
    } 
}

export const updateLayout = async(layoutId,data) =>{
  try{
    const { data:{data:warehouseLayout} } = await axios.put(`warehouse-layout/${layoutId}`,data);
    return warehouseLayout;
  }catch(error){
    toast.error('Error while updating warehouse layout');
    console.log("error", error);
  }
}
